// Prefix marking a 3D model's temporary key while it renders from in-memory
// bytes (local-file direct load) before its background upload resolves to a CDN URL.
export const LOCAL_MODEL_KEY_PREFIX = 'local:';
